import React from 'react';
import PropTypes from 'prop-types';
import './ExperienceList.css';
import ExperienceListItem from './ExperienceListItem/ExperienceListItem';

const ExperienceList = ({
  experiences,
  handleGoToFreelancerOnboarding,
  handleUpdateExperience,
}) => (
  <div className="col-12">
    <div className="row">
      <div className="col">
        <p className="t-19 mt-5 mb-4">Experience</p>
      </div>
    </div>
    <div className="bg-white shadow-mid border position-relative">
      <div className="row">
        <div
          className="plus-button"
          onClick={e => handleGoToFreelancerOnboarding(e, 'experiences')}
        />
        <div className="col-12">
          <div className="row">
            {experiences.map(experience => (
              <ExperienceListItem
                key={experience.id}
                experience={experience}
                handleUpdateExperience={handleUpdateExperience}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

ExperienceList.propTypes = {
  experiences: PropTypes.array,
  handleGoToFreelancerOnboarding: PropTypes.func,
  handleUpdateExperience: PropTypes.func,
};

export default ExperienceList;



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/ExperienceList/ExperienceList.js